import Backbone from 'backbone';
import kendo from '@bingads-webui/kendo/kendo.core';
import '@bingads-webui/kendo/kendo.datepicker';

import template from './date-picker-template.pug';


/**
 * Date picker view that is specialized for countdown editor
 * can not use the shared-component date-picker as date format is fixed, not cultrue-specific
 */
export class DatePickerView extends Backbone.View {
  initialize({ observable, field }) {
    this.observable = observable;
    this.config = field.config;
    this.i18n = field.i18n;
  }

  render() {
    this.$el.html(template());
    const parameters = {
      culture: this.config.get('culture') || 'en-US',
      format: this.config.isResponsiveSearchAd ? 'yyyy-MM-dd' : 'yyyy/MM/dd',
      min: new Date(),
      animation: false,
      footer: false,
      value: this.observable(),
    };

    const elementDatePickerElement = this.$('#countdowndatepicker');

    elementDatePickerElement.kendoDatePicker(parameters);
    const datePickerWidget = elementDatePickerElement.data('kendoDatePicker');

    elementDatePickerElement.on('click', () => {
      datePickerWidget.open();
    });

    datePickerWidget.bind('change', () => {
      const value = kendo.toString(datePickerWidget.value(), parameters.format);

      this.observable(value);
    });

    datePickerWidget.one('open', () => {
      datePickerWidget.dateView.div.click((event) => {
        event.stopPropagation();
      });
      // Fix Bug 3133928: Bad gradient effect of the date picker
      // https://www.telerik.com/forums/how-do-i-change-or-disable-datepicker-animations-for-selecting-months-and-years
      // http://dojo.telerik.com/@ggkrustev/AdexI
      datePickerWidget.dateView.calendar.setOptions({ animation: false });
    });

    elementDatePickerElement.addClass('form-control');

    return this;
  }
}
